/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESProviderSearch.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESPROVIDERSEARCH/FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH`
);

const FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESPROVIDERSEARCH/FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH`
);

export { FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH, FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH };
